import React, { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import './Home.css';
import { AuthContext } from "../../contexts/AuthContext";
import { getAuthRedirectUrl } from "../../utils";

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { AuthContextState } = useContext(AuthContext);
  const { isAuthenticated, isAuthLoading } = AuthContextState;
  const silentLoginAttemptedRef = useRef(false);

  useEffect(() => {
    if (isAuthLoading) return;

    if (isAuthenticated) {
      navigate(`/${i18n.language}/personal_data`, { replace: true });
      return;
    }

    // Unlike ProtectedRoute, a failed attempt here must not force the
    // interactive login form -- this is the public landing page, a guest
    // is allowed to just stay on it. Try the silent carry-over once; if
    // id.express already told us (error=interaction_required) there is no
    // session, don't retry.
    if (silentLoginAttemptedRef.current) return;
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get("error") === "interaction_required") {
      currentUrl.searchParams.delete("error");
      window.history.replaceState({}, document.title, `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
      return;
    }

    silentLoginAttemptedRef.current = true;
    window.location.replace(getAuthRedirectUrl(i18n.language));
  }, [isAuthLoading, isAuthenticated, navigate, i18n.language]);

  return (
    <>

    </>
  );
};

export default Home;
